// extracted by mini-css-extract-plugin
export var btn = "q_b";
export var container = "q_M";
export var smooth = "q_d";
export var submit = "q_c";